// extracted by mini-css-extract-plugin
export default {"wrapper_chips":"Chips__wrapper_chips","single_chip":"Chips__single_chip","chip_radio":"Chips__chip_radio"};